import React, { useRef } from 'react';
import CreateSandboxModal from 'components/modals/CreateSandboxModal';
import { useTranslation } from 'react-i18next';
import { Divider, Button, Segment, Container } from 'semantic';
import {
  Breadcrumbs,
  Layout,
  Search,
  SearchFilters,
  ListHeader,
  RootLayout,
} from 'components';

import { request } from 'utils/api';
import Table from './Table';

const onDataNeeded = async (filters) => {
  return request({
    method: 'POST',
    path: `1/sandboxes/search`,
    body: filters,
  });
};

export default function Sandboxes() {
  const { t } = useTranslation();
  const searchRef = useRef(null);
  return (
    <RootLayout>
      <Container>
        <Search.Provider
          ref={searchRef}
          onDataNeeded={(filters) => onDataNeeded(filters)}>
          <>
            <Breadcrumbs active={t('sandboxes.title', 'Sandboxes')} />
            <ListHeader title={t('sandboxes.title', 'Sandboxes')}>
              <CreateSandboxModal
                title={t('sandboxes.create', 'New sandbox')}
                onSave={() => searchRef.current.reload()}
                onSubmit={(formValues) =>
                  request({
                    method: 'POST',
                    path: `/1/sandboxes`,
                    body: formValues,
                  })
                }
                trigger={
                  <Button
                    primary
                    floated="right"
                    style={{ marginTop: '-5px' }}
                    content={t('sandboxes.create', 'New sandbox')}
                    icon="plus"
                  />
                }
              />
            </ListHeader>
            <Segment>
              <Layout horizontal spread stackable>
                <Layout horizontal stackable center right>
                  <Search.Total />
                  <SearchFilters.Search
                    name="keywords"
                    placeholder={t('sandboxes.filterPlaceholder', 'Name, ID')}
                  />
                </Layout>
              </Layout>
            </Segment>
            <Table />
            <Divider hidden />
            <Search.Status noResults={t('common.noResults', 'No Results')} />
          </>
        </Search.Provider>
      </Container>
    </RootLayout>
  );
}
